import { render, staticRenderFns } from "./PersonInfoAlert.vue?vue&type=template&id=6fa1c6e2&scoped=true&"
import script from "./PersonInfoAlert.vue?vue&type=script&lang=js&"
export * from "./PersonInfoAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa1c6e2",
  null
  
)

export default component.exports